import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(() => ({
	button: {
		height: 49,
		borderRadius: 12,
		margin: 0,
		// padding: "12px 0 !important",
		paddingTop: 10,
		fontWeight: 700,
		width: '100%',
		fontSize: 16,
		border: '1px solid #0184FD',
	},
}));

export default function Outline({ children, disabled = false, onClick }) {
	const classes = useStyle();
	return (
		<Button
			className={classes.button}
			variant="outlined"
			color="primary"
			onClick={onClick}
			disabled={disabled ? disabled : false}
		>
			{children}
		</Button>
	);
}
